import TagApi from 'api/tagApi';
import { formatDateTime, localToUtcDate } from 'library/time';

export const buildTagFilters = (allTags, startDate, endDate, tagIds) => [
  {
    id: allTags ? 'tag__in_all' : 'tag__in',
    value: tagIds
  },
  {
    id: 'start_date__lte',
    value: endDate
  },
  {
    id: 'expiry_date__gte',
    value: startDate
  }
];

export const getAssignedTags = params => TagApi.getObjectTags(params, true);

/**
 * @description Get full tag details
 * @fires TagApi#getObjectTags
 * @param {array} tags Array of tag keys
 * @param {bool} allTags 'And' all tags in search (True) or 'Or' (False)
 * @return {array} Tag Objects
 */
export const getTaggedItems = (tags = [], allTags = true, startDate = null, endDate = null) => new Promise((resolve, reject) => {
  if (tags.length > 0) {
    // Set the query params
    const tagIds = tags.map(item => item.key)
      .join(',');
    const end = endDate ? formatDateTime(endDate) : localToUtcDate();
    const start = startDate ? formatDateTime(startDate) : localToUtcDate();

    // Build the query filters
    const filters = buildTagFilters(allTags, start, end, tagIds);

    const params = {
      page: 0,
      pageSize: 1000,
      filters
    };

    // Fetch the items associated to the tags and
    // return as an array of item ids
    getAssignedTags(params)
      .then(
        (response) => {
          const data = response.data.toJS();
          resolve(data.results);
        },
        (error) => {
          reject(error);
        }
      );
  }
  else {
    resolve([]);
  }
});
